import React from "react";
import shopifyLogo from "../../assets/images/integrations/shopify.svg";
import wordpressLogo from "../../assets/images/integrations/wordpress.svg";
import salesforceLogo from "../../assets/images/integrations/salesforce.svg";
import netsuiteLogo from "../../assets/images/integrations/netsuite.svg";
import zohoLogo from "../../assets/images/integrations/zoho.svg";

const LOGOS = {
	salesforce: {
		src: salesforceLogo,
		alt: "Salesforce",
		tone: "salesforce",
	},
	netsuite: {
		src: netsuiteLogo,
		alt: "NetSuite",
		tone: "netsuite",
	},
	wordpress: {
		src: wordpressLogo,
		alt: "WordPress",
		tone: "wordpress",
	},
	shopify: {
		src: shopifyLogo,
		alt: "Shopify",
		tone: "shopify",
	},
	zoho: {
		src: zohoLogo,
		alt: "Zoho CRM",
		tone: "zoho",
	},
};

export default function IntegrationBrandLogo({ brand, className = "" }) {
	const logo = LOGOS[brand];
	if (!logo) return null;

	return (
		<div
			className={`integration-brand-logo integration-brand-logo--${logo.tone} ${className}`.trim()}
			aria-hidden
		>
			<img src={logo.src} alt="" className="integration-brand-logo__image" />
			<span className="visually-hidden">{logo.alt}</span>
		</div>
	);
}
